import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as tenWebProductAction from '../actions/ten-web-product.action';
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, map, switchMap} from 'rxjs/operators';
import {Utils} from "../../shared/utils/utils";
import * as userActions from '../actions/user.action';
import {LoadUserSuccess} from '../actions/user.action';
import {ProductService} from '../../websites/website/product.service';
import * as fromUserSelectors from "../selectors/user.selector";
import {combineLatest} from "rxjs";
import {Store} from "@ngrx/store";
import {DbStoreState} from "../reducers";

@Injectable()
export class TenWebProductEffect {

  loadUserSuccess$ = createEffect(() => this._actions$.pipe(
    ofType(userActions.LOAD_USER_SUCCESS),
    filter((action: LoadUserSuccess) => !!action.payload),
    map(() => new tenWebProductAction.LoadTenWebProducts())
  ));

  updateUserSubscription$ = createEffect(() => this._actions$.pipe(
    ofType(userActions.UPDATE_USER_SUBSCRIPTION),
    map(() => new tenWebProductAction.LoadTenWebProducts())
  ));

  loadTenWebProducts$ = createEffect(() => this._actions$.pipe(
    ofType(tenWebProductAction.LOAD_TEN_WEB_PRODUCTS),
    switchMap(() => combineLatest(
        this._store.select(fromUserSelectors.getUserSubscription),
        this._store.select(fromUserSelectors.getUser)
      )),
      filter(([userSubscription, user]) => !!userSubscription && !!user),
      switchMap(([userSubscription, user]) => {
        const demoUser = Utils.isDemoUser(userSubscription, user);
      return this._productService.getTenWebProducts(demoUser)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success) {
              const products = [].concat(response.data.plugins, response.data.addons, response.data.themes);
              return new tenWebProductAction.LoadTenWebProductsSuccess(Utils.arrayToEntities(products, 'slug'));
            }

            return new tenWebProductAction.LoadTenWebProductsFail(response.message);
          })
        );
    })
  ));

  constructor(
    private _actions$: Actions,
    private _productService: ProductService,
    private _store: Store<DbStoreState>,
  ) {
  }

}
